import is from '@sindresorhus/is';
import { useContext, useEffect, useRef } from 'react';

import { ApplicationContext } from '../../../shared/source/context/context';

export const useScrollToLocationHash = (): void => {
    const {
        applicationState: {
            location: { hash },
        },
    } = useContext(ApplicationContext);
    const scrollRef = useRef(false);
    const hashRef = useRef(hash);

    useEffect(() => {
        if (is.nonEmptyString(hash)) {
            if (hashRef.current !== hash) {
                hashRef.current = hash;
                scrollRef.current = false;
            }

            if (!scrollRef.current) {
                const id = hash.replace('#', '');
                const element = document.getElementById(id);
                if (is.null(element) === false) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    scrollRef.current = true;
                }
            }
        }
    }, [hash]);
};
